<template>
  <section
    v-if="text || (viewer?.is_owner && ownerViewMode)"
    id="about"
    class="bg-t3-bg-dark max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-12 sm:py-16 font-t3-display"
    aria-labelledby="about-heading-t3"
  >
    <h2 id="about-heading-t3" class="text-2xl sm:text-3xl font-bold mb-8 text-slate-100">{{ $t('public.about') }}</h2>
    <p v-if="text" class="text-slate-300 whitespace-pre-line leading-relaxed">{{ text }}</p>
    <div v-else-if="viewer?.is_owner && ownerViewMode" class="py-4 px-4 rounded border border-dashed border-white/30 bg-white/10">
      <p class="text-sm font-mono text-slate-300">{{ $t('public.noDescriptionSetOwnerMessage') }}</p>
    </div>
  </section>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})
</script>
